import { render, staticRenderFns } from "./EditBucketListModal.vue?vue&type=template&id=55994cae&"
import script from "./EditBucketListModal.vue?vue&type=script&lang=js&"
export * from "./EditBucketListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports